import AboutHeroSectionFa from './AboutHeroSection-fa.json';
import AboutHeroSectionEn from './AboutHeroSection-en.json';
import AboutHeroSectionAr from './AboutHeroSection-ar.json';
import AboutHeroSectionTr from './AboutHeroSection-tr.json';

import BusinessSolutionsFa from './BusinessSolutions-fa.json';
import BusinessSolutionsEn from './BusinessSolutions-en.json';
import BusinessSolutionsAr from './BusinessSolutions-ar.json';
import BusinessSolutionsTr from './BusinessSolutions-tr.json';

import ContactUsFa from './ContactUs-fa.json';
import ContactUsEn from './ContactUs-en.json';
import ContactUsAr from './ContactUs-ar.json';
import ContactUsTr from './ContactUs-tr.json';

import OurBeliefsFa from './OurBeliefs-fa.json';
import OurBeliefsEn from './OurBeliefs-en.json';
import OurBeliefsAr from './OurBeliefs-ar.json';
import OurBeliefsTr from './OurBeliefs-tr.json';

import OurStoryFa from './OurStory-fa.json';
import OurStoryEn from './OurStory-en.json';
import OurStoryAr from './OurStory-ar.json';
import OurStoryTr from './OurStory-tr.json';

import RoadmapFa from './Roadmap-fa.json';
import RoadmapEn from './Roadmap-en.json';
import RoadmapAr from './Roadmap-ar.json';
import RoadmapTr from './Roadmap-tr.json';

import SocialImpactFa from './SocialImpact-fa.json';
import SocialImpactEn from './SocialImpact-en.json';
import SocialImpactAr from './SocialImpact-ar.json';
import SocialImpactTr from './SocialImpact-tr.json';

import UniqueFeaturesFa from './UniqueFeatures-fa.json';
import UniqueFeaturesEn from './UniqueFeatures-en.json';
import UniqueFeaturesAr from './UniqueFeatures-ar.json';
import UniqueFeaturesTr from './UniqueFeatures-tr.json';

export const aboutLocales = {
  fa: {
    AboutHeroSection: AboutHeroSectionFa,
    BusinessSolutions: BusinessSolutionsFa,
    ContactUs: ContactUsFa,
    OurBeliefs: OurBeliefsFa,
    OurStory: OurStoryFa,
    Roadmap: RoadmapFa,
    SocialImpact: SocialImpactFa,
    UniqueFeatures: UniqueFeaturesFa
  },
  en: {
    AboutHeroSection: AboutHeroSectionEn,
    BusinessSolutions: BusinessSolutionsEn,
    ContactUs: ContactUsEn,
    OurBeliefs: OurBeliefsEn,
    OurStory: OurStoryEn,
    Roadmap: RoadmapEn,
    SocialImpact: SocialImpactEn,
    UniqueFeatures: UniqueFeaturesEn
  },
  ar: {
    AboutHeroSection: AboutHeroSectionAr,
    BusinessSolutions: BusinessSolutionsAr,
    ContactUs: ContactUsAr,
    OurBeliefs: OurBeliefsAr,
    OurStory: OurStoryAr,
    Roadmap: RoadmapAr,
    SocialImpact: SocialImpactAr,
    UniqueFeatures: UniqueFeaturesAr
  },
  tr: {
    AboutHeroSection: AboutHeroSectionTr,
    BusinessSolutions: BusinessSolutionsTr,
    ContactUs: ContactUsTr,
    OurBeliefs: OurBeliefsTr,
    OurStory: OurStoryTr,
    Roadmap: RoadmapTr,
    SocialImpact: SocialImpactTr,
    UniqueFeatures: UniqueFeaturesTr
  }
};